import { IGetAllResponse, IGetOneResponse } from "../Utilis/Types/Generic";
import { Report } from "../Utilis/Types/Report";
import { ReportCategory } from "../Utilis/Types/Report";
import { ApiService } from "./ApiService";

export class ReportService extends ApiService {
  static pathName = "report";

  static getReportsAdmin = (
    reportCategory: ReportCategory,
    clientId: string
  ): Promise<IGetAllResponse<Report>> => {
    return this.get(`${this.pathName}/admin/${reportCategory}/${clientId}`);
  };

  static getUserReports = (
    reportCategory: string
  ): Promise<IGetAllResponse<Report>> => {
    return this.get(`${this.pathName}/${reportCategory}`);
  };

  static getOneReport = (id: number): Promise<IGetOneResponse<Report>> => {
    return this.get(`${this.pathName}/${id}`);
  };

  static changeReportVisibility = (
    reportId: string,
    visible: boolean
  ): Promise<IGetOneResponse<Report>> => {
    return this.patch(`${this.pathName}/visible`, { reportId, visible });
  };

  static uploadReport = async (
    category: ReportCategory,
    clientId: string,
    file: File
  ): Promise<IGetOneResponse<Report>> => {
    const formData = new FormData();
    formData.append("category", category);
    formData.append("clientId", clientId);
    formData.append("file", file);

    return this.post(`${this.pathName}/upload`, formData, undefined, {
      "Content-Type": "multipart/form-data",
    });
  };

  static downloadReport = (id: string): Promise<any> => {
    return this.get(`${this.pathName}/download/${id}`);
  };

  static deleteReport = (id: string) => {
    return this.delete(`${this.pathName}/${id}`)
  }
}
